import { useState, useRef, useEffect, useContext } from 'react';
import { Link, useNavigate, useSearchParams } from "react-router-dom";

// import VideoThumbnail from '../../Assets/Images/video-thumbnail.png';
import videoThumbnail from '../../Assets/Images/thumbnail.png';
import ImgLeft from '../../Assets/Images/thumbnail.png';
import ImgLeftMobile from '../../Assets/Images/thumbnail-mobile.png'
// import videoThumbnailMobile from '../Assets/Images/video-thumbnail-mobile.png';
// import playButton from '../Assets/Images/play-button.png';
import playBtnImg from '../../Assets/Images/play-btn.png';
import playBtnHoverImg from '../../Assets/Images/play-btn-hover.png';
import clockImg from '../../Assets/Images/clock-icon.svg';
import { Close } from "@mui/icons-material";
import useWindowDimensions from '../../Hooks/useWindowDimensions';
import { Button, CircularProgress } from '@mui/material';
import { fetchAssessmentProgress, updateAssessmentStatus } from '../../api';
import AssessmentQuestionContext from '../../Store/AssessmentQuestionContext';
import { isEqual } from 'lodash';

const Start = props => {

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { windowWidth } = useWindowDimensions();
  const client_id = searchParams.get("clientId")

  const [isLoading, setIsLoading] = useState(false);
  const [playingVideo, setPlayingVideo] = useState(false);
  const [startPlaying, setStartPlaying] = useState(false);
  const [playBtn, setPlayBtn] = useState(playBtnImg);

  const vidRef = useRef(null);
  const introElmRef = useRef(null);
  const videoElmRef = useRef(null);
  const hasRequestedAssessmentData = useRef(false);

  const hasLeader = searchParams.get("leader");

  const leader = searchParams.get('leader')
  const member = searchParams.get('member')
  const assessmentId = searchParams.get('assessmentId')
  const selfUserName = searchParams.get('userName')
  const clientId = searchParams.get('clientId')
  const orgId = searchParams.get('orgId')
  const clientName = searchParams.get('client')
  const isLastAsmt = searchParams.get('isLastAsmt')
  const assessCtx = useContext(AssessmentQuestionContext);
  const userHash = assessmentId;
  const storedAssessmentData = JSON.parse(localStorage.getItem(`searchParams-${userHash}`)) || {};
  const hasStoredAssessmentData = Boolean(
    storedAssessmentData.userName &&
    storedAssessmentData.orgId &&
    storedAssessmentData.clientId &&
    storedAssessmentData.designation
  );

  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem(`searchParams-${userHash}`)) || {};
    const searchParamsData = {
      ...storedData,
      leader: leader || storedData.leader || null,
      member: member || storedData.member || null,
      assessmentId,
      selfUserName: selfUserName || storedData.selfUserName || null,
      clientId: clientId || storedData.clientId || null,
      orgId: orgId || storedData.orgId || null,
      clientName: clientName || storedData.clientName || null,
      isLastAsmt: isLastAsmt === 'true'
    };
    assessCtx?.setOrgId(orgId)
    assessCtx?.setClientId(clientId)
    localStorage.setItem(`searchParams-${userHash}`, JSON.stringify(searchParamsData));
    console.log('storedData', searchParamsData)
  }, [leader, member, assessmentId, selfUserName, clientId, orgId]);

  // useEffect(() => {
  //   if (windowWidth <= 550) {
  //     document.body.style.background = `linear-gradient(180deg, #172D43 0%, rgba(39, 80, 120, 0.9) 75%, #343333 75%, #343333 100%)`;
  //   } else {
  //     document.body.style.background = `linear-gradient(180deg, #172D43 0%, rgba(39, 80, 120, 0.9) 100%)`;
  //   }
  // }, [windowWidth]);

  // useEffect(() => {
  //   if(display === "preview") {
  //     console.log("changed background img for embedded preview display...");
  //     document.body.style.background = `#242424 url(${introBgImg}) repeat`;
  //   } else {
  //     document.body.style.background = `#414042`;
  //   }
  // }, [display]);

  const createAssessment = () => {

    let leaderId = 0;
    let userId = 0;
    let isMember = false;
    if (searchParams?.get("leader")) {
      leaderId = searchParams?.get("leader");
      userId = searchParams?.get("user");
      isMember = true;
    }

    const clientId = process.env.REACT_APP_CLIENT_ID;
    fetch(process.env.REACT_APP_API_URI + '/v3/user/assessment', {
      method: 'POST',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ clientId, isMember, leaderId, userId })
    }).then(response => {
      return response.json();
    }).then(data => {
      if (data.status === "success") {
        const assessmentName = localStorage.getItem("assessmentName");
        navigate(`/explainer/${data.id}/?${searchParams}`, { replace: true });
        // navigate(`/${assessmentName}/assessment/` + data.id + "/815?" + searchParams, { replace: true });
        console.log("data", data);
      } else {
        // setIsSaving(false);
        // setOpenSnackbar(true);
      }
    }).catch((err) => console.error("Failed to create new assessment...", err));
  }

  const createAssessmentAndUser = async ({ shouldNavigate = true } = {}) => {

    const localStorageKey = `searchParams-${userHash}`;
    const storedData = JSON.parse(localStorage.getItem(localStorageKey)) || {};
    const hasStoredData = Boolean(
      storedData.userName &&
      storedData.orgId &&
      storedData.clientId &&
      storedData.designation
    );

    if (hasStoredData) {
      if (shouldNavigate) {
        navigate(`/explainer/${assessmentId}/`, { replace: true });
      }
      return;
    }

    // const assessmentId = process.env.REACT_APP_CLIENT_ID;
    const templateAssessmentId = 78;
    let userId = 0;
    let userDetails = {
      fullName: "",
      firstName: "",
      lastName: "",
      email: "",
      nameType: "none",
      phone: "",
    };
    let firstPage = "assessment";
    let pageId = 866;
    let designation = "member";
    let hasParent = false;
    let parentId = 0;
    if (searchParams.get("leader")) {
      parentId = searchParams.get("leader");
      hasParent = true;
    }




    try {
      const response = await fetch(process.env.REACT_APP_API_URI + '/v4/user/assessmentAndUser', {
        method: 'POST',
        mode: 'cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ assessmentId: templateAssessmentId, userId, userHash, userDetails, firstPage, pageId, designation, hasParent, parentId })
      })
      const data = await response.json();
      if (data.status === "success") {
        const asmtDetails = data.asmtDetails || {};
        const finalAssessmentId = searchParams.get("assessmentId") || data.id;
        const assessmentParams = new URLSearchParams();

        ["isLastAsmt"].forEach((key) => {
          const value = searchParams.get(key);
          if (value) assessmentParams.set(key, value);
        });

        const updatedStoredData = {
          ...storedData,
          assessmentId: finalAssessmentId,
          selfUserName: asmtDetails.userName || selfUserName || null,
          userName: asmtDetails.userName || selfUserName || null,
          orgId: asmtDetails.orgid || orgId || null,
          clientId: asmtDetails.client_id || clientId || null,
          designation: asmtDetails.designation || storedData.designation || null,
          leader: asmtDetails.leaderName || leader || null,
          member: asmtDetails.memberName || member || null,
          clientName: asmtDetails.clientName || clientName || null
        };
        localStorage.setItem(localStorageKey, JSON.stringify(updatedStoredData));
        assessCtx?.setLeaderName(updatedStoredData.leader);
        assessCtx?.setOrgId(updatedStoredData.orgId);
        assessCtx?.setClientId(updatedStoredData.clientId);
        window.dispatchEvent(new Event("assessment-details-updated"));

        const asmtStatus = await updateAssessmentStatus({
          assessmentId: finalAssessmentId,
          deploymentId: asmtDetails.client_id || client_id,
          status: "pending"
        });

        if (shouldNavigate) {
          navigate(`/explainer/${finalAssessmentId}/?${assessmentParams.toString()}`, { replace: true });
        }
        // navigate(`/${assessmentName}/assessment/` + data.id + "/815?" + searchParams, { replace: true });
        console.log("asmtStatus", asmtStatus);
      }
    } catch (err) {
      console.error("Failed to create new assessment...", err);
    }
  }

  useEffect(() => {
    if (!userHash || hasStoredAssessmentData || hasRequestedAssessmentData.current) return;

    hasRequestedAssessmentData.current = true;
    setIsLoading(true);
    createAssessmentAndUser({ shouldNavigate: false })
      .finally(() => setIsLoading(false));
  }, [userHash, hasStoredAssessmentData]);



  const howItWorksLink = () => {
    if (searchParams == "") {
      return "/how-it-works";
    } else {
      return "/how-it-works?" + searchParams;
    }
  }
  // console.log(searchParams.get("display"));

  const assessmentLink = () => {

    if (isLoading) return;
    setIsLoading(true);

    const assessmentId = searchParams?.get("assessmentId")

    const navigateToAnsweredQuestion = async () => {
      const fetchedProg = await fetchAssessmentProgress(assessmentId)
      const fetchedProgAllQuestions = fetchedProg?.data?.flatMap(el => el?.data || []);
      const lsAllQuestions = assessCtx?.allQuestions?.flatMap(el => el?.data || []);
      let fetchedQIndex = fetchedProgAllQuestions?.findIndex(item => item.answer === undefined);
      let lsQIndex = lsAllQuestions?.findIndex(item => item.answer === undefined);

      const threeWaytieBreakersPageIdArray = [955, 956, 957, 958]
      const twoWaytieBreakersPageIdArray = [949, 959, 966, 967, 968, 969, 970]
      const twoWaytieBreakersPageIdArrayRound2 = [985, 986, 987, 989, 990, 978]

      const threeWaytieBreakersPageIdArrayLeadership = [960, 961, 962, 963]
      const twoWaytieBreakersPageIdArrayLeadership = [965, 964, 971, 964, 972, 973, 974, 975]
      const twoWaytieBreakersPageIdArrayRound2Leadership = [984, 996, 997, 998, 999, 1000, 1001]



      if (!isEqual(assessCtx?.allQuestions, fetchedProg?.data) && lsQIndex < fetchedQIndex) {
        setIsLoading(true)
        assessCtx?.setAllQuestions(fetchedProg?.data)
        localStorage.setItem(`allQuestions-${assessmentId}`, JSON.stringify(fetchedProg?.data))
      }

      console.log("fetchedProg", fetchedProg)

      if (fetchedProg?.data?.length > 0) {
        const pageId = fetchedProg?.data?.[fetchedProg?.data?.length - 1]?.pageId
        const isStarterTb = twoWaytieBreakersPageIdArray?.includes(parseInt(pageId)) || threeWaytieBreakersPageIdArray?.includes(parseInt(pageId)) || twoWaytieBreakersPageIdArrayRound2?.includes(parseInt(pageId))
        const isLeaderTb = twoWaytieBreakersPageIdArrayLeadership?.includes(parseInt(pageId)) || threeWaytieBreakersPageIdArrayLeadership?.includes(parseInt(pageId)) || twoWaytieBreakersPageIdArrayRound2Leadership?.includes(parseInt(pageId))
        const isStarterTbR2 = twoWaytieBreakersPageIdArrayRound2?.includes(parseInt(pageId))
        const isLeaderTbR2 = twoWaytieBreakersPageIdArrayRound2Leadership?.includes(parseInt(pageId))

        assessCtx?.setIsFetched(true)

        if (isStarterTb) {
          navigate(`/assessment/${assessmentId}/${pageId}/?next_page=${953}`)
        }
        else if (isLeaderTb) {
          navigate(`/assessment/${assessmentId}/${pageId}/?next_page=${954}`)
        }
        else if (isStarterTbR2) {
          navigate(`/assessment/${assessmentId}/${pageId}/?next_page=${947}`)
        }
        else if (isLeaderTbR2) {
          navigate(`/assessment/${assessmentId}/${pageId}/?next_page=${948}`)
        }
        else {
          navigate(`/assessment/${assessmentId}/${pageId}`)
        }
      }
      else {
        createAssessmentAndUser();
      }
    }

    // navigateToAnsweredQuestion(); // saved progress functionality
    createAssessmentAndUser();
  }

  const preAssessmentQuestionsLink = () => {
    navigate("/pre-additional-questions?" + searchParams);
  }

  const introPageLink = () => {
    // createAssessment();
    createAssessmentAndUser();
    // navigate("/intro/" + id + "?" + searchParams);
  }

  const playVideo = (e) => {

    if (windowWidth > 830) {
      const introElm = introElmRef.current;
      const videoElm = videoElmRef.current;

      introElm.style.cssText = "width: 0%; padding: 0; overflow: hidden;"
      videoElm.style.cssText = "width: 100%; margin: 0 auto; background-color: #0E435C; border-radius: 0;";
      // if(display === "preview") {
      //   videoElm.style.background = `#242424 url(${introBgImg}) repeat`;
      // } else videoElm.style.backgroundColor = "#435B63";
    }
    vidRef.current.play();
    setPlayingVideo(true);
    if (!startPlaying) {
      setStartPlaying(true);
    }
  }

  const pauseVideo = (e) => {
    // vidRef.current.pause();
    // setPlayingVideo(false);
    vidRef.current.pause();

    if (windowWidth > 830) {
      const introElm = introElmRef.current;
      const videoElm = videoElmRef.current;

      introElm.style.cssText = "width: 50%; padding: 20px 5%; overflow: hidden;";
      videoElm.style.cssText = "width: 50%; margin: 0 auto; background-color: #0E435C; border-top-left-radius: 10px; border-bottom-left-radius: 10px;";
      // if(display === "preview") {
      //   videoElm.style.background = `#242424 url(${introBgImg}) repeat`;
      // } else videoElm.style.backgroundColor = "#435B63";
    }
    setPlayingVideo(false);
  }

  const handleVideoPlaybackEnd = () => {
    setPlayingVideo(false);

    if (windowWidth > 830) {
      const introElm = introElmRef.current;
      const videoElm = videoElmRef.current;

      introElm.style.cssText = "width: 50%; padding: 20px 5%; overflow: hidden;";
      videoElm.style.cssText = "width: 50%; margin: 0 auto; background-color: #0E435C; border-top-left-radius: 10px; border-bottom-left-radius: 10px;";

      // if(display === "preview") {
      //   videoElm.style.background = `#242424 url(${introBgImg}) repeat`;
      // } else videoElm.style.backgroundColor = "#435B63";
    }
    showThumbnail();
    showPlayButton();
  }

  const showThumbnail = () => {
    if (playingVideo) {
      return <img alt="video thumbnail" className="thumbnail" src={videoThumbnail} style={{ opacity: '0' }} onClick={(e) => pauseVideo(e)} />;
    } else {
      if (startPlaying) {
        return null
      } else {
        return <img alt="video thumbnail" className="thumbnail" src={videoThumbnail} />
      }
    }
  }

  const showPlayButton = () => {
    if (playingVideo) {
      return null
    } else {
      return <img alt="play button" className="playbtn" src={playBtn}
        onMouseOver={() => setPlayBtn(playBtnHoverImg)}
        onMouseOut={() => setPlayBtn(playBtnImg)}
        onClick={(e) => playVideo(e)} />;
    }
  }


  const vidsrcURL = "https://40parables-assets.s3.amazonaws.com/Guest-Ready-Intro-Video.mp4";

  return (
    <>
      {/* <div className='intro'>
        <h3>If you were at our service, we'd love to hear from you!</h3>
      </div>
    <div className='main-container'>
      <div className="container start"> */}
      {/* <div className="video" ref={videoElmRef}>
        <video ref={vidRef} onEnded={handleVideoPlaybackEnd}>
          <source src={vidsrcURL} type="video/mp4" />
        </video>
        {showThumbnail()}
        {showPlayButton()}

        {playingVideo && <Close className="close-video" style={{
          position: "absolute", height: "20px", width: "20px", color: "#fefefebb", opacity: 0.75, zIndex: 99, padding: "15px", top: "5px", cursor: "pointer",
          right: windowWidth > 1100 ? "70px" : "5px"
        }} onClick={(e) => pauseVideo(e)} />}

      </div> */}
      {/* { windowWidth < 550 ? 
        <div style={{ width: '100%', height: '12px', backgroundColor: '#0E435C'}}></div> : <div></div>
      } */}
      {/* <div className="intro" ref={introElmRef}>
        <h1>How effective is your <br></br> marriage ministry strategy?</h1>
        <p className='intro-para'>See how you compare* with similarly-sized American churches</p>
        <div className="completion">See how you compare* with similarly-sized American churches</div>
        <ol className="intro-points-list">
          {searchParams.get("leader") ? <>
            <li>Take this 3-minute assessment</li>
            <li>View your results instantly</li>
            <li>Align on the best next step for your ministry</li>
          </> : <>
            <li>Take this 3-minute assessment</li>
            <li>Invite your team to take it, too, after you do</li>
            <li>View everyone's results on one dashboard</li>
            <li>Align on the best next step for your ministry</li>
            <li>Find out how your church is faring in 5 critical areas of generosity.</li>
          </>}
        </ol>

        <div className="completion">
          <div className='btn-container'>
          <Link to={assessmentLink()} className="cta">Get Started</Link>
          <Button className="cta" onClick={createAssessment}>TEST AND SEE</Button>
          </div>
          <div className='time-estimate'>
            <div className='img-container'><img className='clock-icon' src={clockImg} alt="estimated time" /></div><span style={{ margin: "auto" }}>{searchParams.get("leader") ? "3 min" : "3 min"}</span>
          </div>
        </div>


        <div className='para-container'>
          <p className='para'>*We can help you compare your church's data to that of about 10,000 churches
          in the US through our church engagement research.</p>
        </div>
      </div> */}
      {/* <div className='contents'>
        <p>Please share your feedback on this 30-second survey.</p>
        <div className="completion">
          <div className='btn-container'>
            <Button onClick={() => assessmentLink()} className="cta">Get Started!</Button>
          </div>
          <div className='time-estimate'>
            <div className=''><img className='clock-icon' src={clockImg} alt="estimated time" /></div><span >30 seconds</span>
          </div>
        </div>
      </div>
      </div>
    </div> */}
      <div className="start-page" style={{ position: "relative" }}>
        {isLoading && (
          <div
            role="status"
            aria-label="Loading assessment details"
            style={{
              position: "absolute",
              inset: 0,
              zIndex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#ffffff",
              borderRadius: "inherit"
            }}
          >
            <CircularProgress size={56} style={{ color: "#00577D" }} />
          </div>
        )}
        <div className="image-left">
          {windowWidth < 600 ? <img src={ImgLeftMobile} alt="left img" /> : <img src={ImgLeft} alt="left img" />}
        </div>
        <div className="content-right">
          {/* <h1 className="title">{hasLeader ? 'Share. Support. Strengthen.' : windowWidth > 650 ? 'DISCOVER WHO YOU ARE' : 'DISCOVER YOUR TRUE SELF'}</h1> */}
          <h1 className="title">{hasLeader ? 'Share. Support. Strengthen.' : 'STEP INTO ALIGNMENT'}</h1>
          <p className='intro-sentence' style={{ paddingTop: hasLeader ? "30px" : "0px" }}>{hasLeader ? windowWidth < 600 ? 'You’ve been invited to share insights as part of a 360 assessment.' : 'You’ve been invited to share insights as part of a 360 assessment.' : ''}</p>
          {/* {hasLeader && windowWidth < 600 && <p className="intro-sentence line-two">Take just 7 minutes to:</p>} */}
          <div className="paragraphs">
            {hasLeader ?
              windowWidth < 600 ?
                <>
                  <p className='content-two-mobile'>Your voice matters.</p>
                  <p className='content-two-mobile'>Your feedback fuels growth.</p>
                  <p className='content-two-mobile'>Your insights build a better team </p>
                </>
                :
                <>
                  <p className='content-two'>Your voice matters.</p>
                  <p className='content-two'>Your feedback fuels growth.</p>
                  <p className='content-two'>Your insights build a better team.</p>
                </>
              :
              // windowWidth > 650 ?
              // <p className="content-bold first-para">Experience the clarity and confidence that comes from knowing who you are and how you lead.</p>
              //   : 
              // <p className="content-bold first-para">
              //   This powerful assessment will help you your mind, heart, soul, and strength so you can:
              // </p>
              <p className="content-bold first-para">Experience the clarity and confidence that comes from knowing who you are and how you lead.</p>
            }
            {/* <p className="content-bold content-two">{hasLeader ? "" : windowWidth > 650 ? "This insight will empower you to flourish personally and professionally by:" : "In just 7 minutes, you’ll"}</p> */}
            <p className="content-bold content-two">{hasLeader ? "" : "This powerful assessment will help you align your mind, heart, soul, and strength so you can:"}</p>
            {hasLeader ?
              <>
                <p className='list-items-leader'>
                  Please share your valuable opinion to help us shape a thriving workplace.<br />
                </p>
                <div className='better-together'>#bettertogether</div>
              </>

              :
              // windowWidth > 650 ? 
              // <p className='list-items'>
              //   1. Revealing your default wiring<br />
              //   2. Unlocking how you flow and adapt
              //   <br />
              //   3. Identifying clear next steps for growth
              // </p>
              // : <p className="list-items">
              //   1. See how you show up in the world <br />
              //   2. Understand how you flow and lead <br />
              //   3. Identify clear next steps for growth
              // </p>
              <p className='list-items'>
                1. Discover your core wiring<br />
                2. Unlock your natural flow
                <br />
                3. Focus your strengths and growth areas
              </p>
            }
            {/* {hasLeader && windowWidth < 600 &&  <div className='better-together-mobile'>#bettertogether</div>} */}
          </div>
          <div className="cta-container">
            <Button className="cta" style={{ minWidth: isLoading ? '165px' : 'auto', position: 'relative' }} disabled={isLoading} onClick={() => assessmentLink()} > {isLoading ? <CircularProgress size={20} color="inherit" /> : "Get Started"}</Button>
            {/* <div className='time-estimate'>
                <img className='clock-icon' src={clockImg} alt="estimated time" /> <span>{searchParams.get("leader") ? "7 min" : "7 min"}</span>
              </div> */}
          </div>
        </div>
      </div>
    </>

  );
}

export default Start;
